document.addEventListener('DOMContentLoaded', function () {
  const preloader = document.getElementById('page-preloader');
  const bar = document.querySelector('.preloader-bar');
  const text = document.querySelector('.preloader-text');

  let progress = 0;

  const simulateProgress = () => {
    const state = document.readyState;

    if (state === 'interactive' && progress < 60) {
      progress += 1;
    } else if (state === 'complete') {
      progress += (100 - progress) * 0.08;
    }

    // Visuelles Update
    const rounded = Math.floor(progress);
    bar.style.width = rounded + '%';

    // Optional mit Prozentanzeige
    if (text) {
      text.innerHTML = `Dein Portal wird geöffnet... ${rounded}%`;
    }

    // Wenn "fast vollständig", dann hart abschließen
    if (progress >= 99.5) {
      bar.style.width = '100%';
      text.innerHTML = `Dein Portal wird geöffnet... 100%`;

      setTimeout(() => {
        preloader.classList.add('loaded');
        setTimeout(() => {
          preloader.style.display = 'none';
        }, 800);
      }, 300);
    } else {
      requestAnimationFrame(simulateProgress);
    }
  };

  simulateProgress();
});
